import { useTranslation } from '../../core/hooks/use-translation';

/**
 * The mark in the top bar and in the footer: the icon, the name, and the full stop after it. The
 * name is never translated, so it is one string and the stop is markup — the live site keeps the
 * stop inside a translated HTML fragment, where it is a character a translator can lose.
 */
export function BrandLogo({ stopColor }: { stopColor?: string }) {
    const { t } = useTranslation();

    return (
        <>
            <div className="logo-icon">
                <img src="/favicon.ico" alt={t('brand.name')} />
            </div>
            <span className="logo-text">
                {t('brand.name')}
                <span style={stopColor === undefined ? undefined : { color: stopColor }}>.</span>
            </span>
        </>
    );
}
